import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Card, CardContent, Heading, LargeSearch, Notice, Text, TextField } from 'telia-front-react';
import Config from '../Config';
import RouteStore from '../stores/RouteStore';
import { TranslationsContext } from '@teliaee/telia-translate';
import { getDomainError } from '../util/DomainUtil';

export interface DomainSearchProps {
  headingLevel?: number;
  routeStore?: RouteStore;
}

const DomainSearch = (props: DomainSearchProps) => {
  const translate = React.useContext(TranslationsContext).translate;
  const { headingLevel, routeStore } = props;

  const [searchInput, setSearchInput] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState(null);

  const handleSearchChange = (value: string) => {
    if (errorMessage) {
      setErrorMessage(null);
    }
    setSearchInput(value.toLowerCase());
  };

  const submitSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const error = getDomainError(searchInput);
    setErrorMessage(error);

    if (!error) {
      routeStore.push(`${Config.teliaWebSelfServiceUrl}/teenused/kodulehe-majutus/tellimine/domain`, { domainName: searchInput });
    }
  };

  return (
    <Card padding="medium">
      <CardContent>
        <Text className="text-center">
          <Heading level={headingLevel || 1} className="h2">
            {translate('domain.search.heading')}
          </Heading>
          <Notice size="small" className="text-light" align="center">
            {translate('domain.search.heading.notice')}
          </Notice>
          <LargeSearch id="domain-search-form" onSubmit={submitSearch} helper={errorMessage ? { type: 'error', text: translate(errorMessage) } : undefined}>
            <TextField id="domain" label={translate('domain.search.label')} value={searchInput} onChange={handleSearchChange} />
          </LargeSearch>
        </Text>
      </CardContent>
    </Card>
  );
};

export default inject('routeStore')(observer(DomainSearch));
